import { To } from 'react-router-dom';

import { Breadcrumbs } from '../../types/breadcrumbs';

export type BreadcrumbsInput = [To | undefined, string | undefined][];

export function useBreadcrumbs(breadcrumbs: BreadcrumbsInput): Breadcrumbs {
  return breadcrumbs.map(([to, label]) => [to !== undefined ? to : '#', label !== undefined ? label : 'Loading...']);
}
